define('shared/util/adyen/addCSSClassForStoreDetails',[],function () {
    return function ($form) {
        var $allStoreDetailsTickBoxes = 
            $form.find('input[type=checkbox][name=storeDetails]');
        if (!$allStoreDetailsTickBoxes || $allStoreDetailsTickBoxes.length === 0) {
            return;
        }
        $allStoreDetailsTickBoxes.each(function(index, el) {
            el.parentNode.className += ' chckt-form-label--store-details';
        });
    };
});
